function objectToFlattenMap(prefix, object) {
  let res = new Map();

  if (object) {
    for (let field of Object.keys(object)) {
      if (typeof object[field] === 'object') {
        let newPrefix = '';
        if (prefix !== '') {
          newPrefix = prefix + '_' + field;
        } else {
          newPrefix = field;
        }
        let subObject = objectToFlattenMap(newPrefix, object[field]);
        res = new Map([...res, ...subObject]);
      } else {
        // if (object[field] && object[field] != null) {
        // if (object[field]) {
        if (prefix !== '') {
          if (prefix === 'dynamicFields') {
            res.set(field, object[field]);
          } else {
            res.set(prefix + '_' + field, object[field]);
          }
        } else {
          res.set(field, object[field]);
        }
        // }
      }
    }
  }

  return res;
}

function mapToObject(map) {
  let res = {};
  for (let entry of map.entries()) {
    // console.log(JSON.stringify(entry));
    res[entry[0]] = entry[1];
  }

  return res;
}

function objectToFlattenObject(object) {
  let map = objectToFlattenMap('', object);
  // console.log(JSON.stringify(map));
  return {...mapToObject(map)};
}

function getAllFlattenFieldNames(object) {
  let map = objectToFlattenMap('', object);

  let res = [];
  for (let field of map.keys()) {
    res.push(field);
  }
  // console.log('FieldList: ' +res );
  return res;
}


export {objectToFlattenObject, getAllFlattenFieldNames};